import React, { Component } from 'react';

import Header from '../components/Header/Header';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';
import Staking from '../components/Staking/StakingOne';
import Staking0421 from '../components/Staking/Staking0421';
import Footer from '../components/Footer/Footer';


class StakingNewest extends Component {


    render() {
        return (
            <div className="main">
                <Header />
                <Breadcrumb title="Staking Style 1" subpage="Staking" page="Staking Style 1" />
                <Staking0421 />
                <Footer />
            </div>
        );
    }
}

export default StakingNewest;